module.exports = __webpack_public_path__ + "images/warning.5751e350e05225689f331595aae87007.svg";